const specificLocaleName = new Map([
    ["fr", "fr-CA"],
    ["es-419", "es"],
    ["zh-Hans", "zh-CN"],
    ["ar", "ar-001"]
]);

export const convertToIamLocale = (locale: string) => {
    const iamLocal = specificLocaleName.get(locale);
    return iamLocal || locale;
};
